import { Copies } from "../../../../../../shared/hooks/useCopies";
import { ProgramType } from "../../../../../../shared/enums/ProgramType";
import Icon from "../../../../../../assets/icons";
import { ConsoleRouteMap } from "../../../../routes/routes";
import Authority from "../../../../../../shared/enums/Authority";
import React from "react";
import { NavOptionType } from "../../../../components/navigation/context/type";

enum NAV_OPTION_KEYS {
  FSL_REQUEST = "fsl-request",
  FSL_OPT_IN = "fsl-optin",
  EXHIBITORS_LIST = "exhibitor-list"
}

export function getFslNavChildOption({
  copies,
  programType
}: {
  copies: Copies;
  programType?: ProgramType;
}): Array<NavOptionType> {
  const navOptions = [
    {
      key: NAV_OPTION_KEYS.FSL_REQUEST,
      icon: <Icon.RequestSGL />,
      displayLabel: `${copies.get("system.generated.list.request")}`,
      path: ConsoleRouteMap.PROGRAM.CONFIGURATIONS.featuredLists.path,
      requiredAuthorities: [Authority.PROGRAM_READ],
      className: "selection_featurelist_item"
    },
    {
      key: NAV_OPTION_KEYS.FSL_OPT_IN,
      icon: <Icon.RequestOptIn />,
      displayLabel: `${copies.get("system.generated.list.optin")}`,
      path: ConsoleRouteMap.PROGRAM.CONFIGURATIONS.featuredLists.OPTIN.path,
      requiredAuthorities: [Authority.PROGRAM_READ],
      className: "selection_featurelist_item"
    }
  ];
  const exhibitorNaVOption = {
    key: NAV_OPTION_KEYS.EXHIBITORS_LIST,
    icon: <Icon.StoreLight />,
    displayLabel: copies.get("system.generated.list.exhibitor.list"),
    path: ConsoleRouteMap.PROGRAM.CONFIGURATIONS.featuredLists.EXHIBITOR.path,
    requiredAuthorities: [Authority.PROGRAM_READ],
    className: "selection_featurelist_item"
  };

  switch (programType) {
    case ProgramType.CONNECTIONS_PROGRAM:
      return [...navOptions, exhibitorNaVOption].filter(o => o.key !== NAV_OPTION_KEYS.FSL_OPT_IN);
    case ProgramType.TRADE_PROGRAM:
    case ProgramType.MEETUP_PROGRAM:
      return [...navOptions];
    default:
      return navOptions;
  }
}
